<template>
  <div class="warp">
    <div class="hotViewBgScroll" id="hotViewBgScroll">
      <div class="hotViewBg" :style="{ width: `${curComponent.imgWidth}px` }">
        <img :src="imgUrl" alt="" @load="imgLoad" />
        <div class="hotViewItemsBg" v-if="imgHeight">
          <vue-draggable-resizable
            v-for="(item, index) in value"
            :ref="`draggableResizable${item.id}`"
            :key="index"
            :x="item.x"
            :y="item.y"
            :w="item.width"
            :h="item.height"
            :min-width="50"
            :min-height="28"
            :parent="true"
            class="hotView"
            @activated="toggleActivated(item, true)"
            @deactivated="toggleActivated(item, false)"
            @dragging="(x, y) => handleDragging(x, y, item)"
            @resizestop="handleResizestop(index)"
            @dragstop="handleDragstop(index)"
            @resizing="
              (x, y, width, height) => handleResizing(x, y, width, height, item)
            "
          >
            <div class="draggable-item">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="control-menu" v-show="item.activated">
              <div>
                <SelectJumpLink
                  :path="value[index].path"
                  type="icon"
                  mode="direct"
                  :ref="`selectJumpLink${index}`"
                  @change="val => jumpTypeChange(val, index)"
                  @visibleChange="visibleChange"
                />
              </div>
              <div class="delete-icon-box" @click="deleteItem(index)">
                <i class="el-icon-delete"></i>
              </div>
            </div>
          </vue-draggable-resizable>
        </div>
        <ReferenceLine :lines="lines" />
      </div>
    </div>
    <div class="hotViewEdit">
      <div class="editTitle">
        添加热区
        <span>（最多可添加50个热区）</span>
      </div>
      <div class="editItemsBg">
        <div class="editItem " v-for="(_, index) in value" :key="index">
          <div>
            <span class="editItemTitle">热区{{ index + 1 }}</span>
            <div class="editItemContent">
              <SelectJumpLink
                :path="value[index].path"
                @change="val => jumpTypeChange(val, index)"
              />
            </div>
            <img
              @click="copy(value[index], value, index)"
              src="../../../../assets/images/copy-icon.png"
              alt=""
            />
            <i class="el-icon-circle-close" @click="deleteItem(index)"></i>
          </div>
        </div>
      </div>
      <el-button
        class="addHotSpotBtn"
        type="primary"
        :disabled="value && value.length >= 50"
        @click="addHotSpotHandle()"
      >
        <i class="iconfont-mini-app icon-bianjirequ"></i>
        添加热区
      </el-button>
    </div>
  </div>
</template>

<script>
import ReferenceLine from "./ReferenceLine";

import SelectJumpLink from "../../../../components/SelectJumpLink";
import VueDraggableResizable from "vue-draggable-resizable";
import "vue-draggable-resizable/dist/VueDraggableResizable.css";
import { generateID } from "../../../../utils/utils";
export default {
  inject: ["control"],
  props: {
    value: {
      type: Array,
      default: []
    },
    imgUrl: {
      type: String,
      require: true
    }
  },
  components: {
    ReferenceLine,
    SelectJumpLink,
    VueDraggableResizable
  },
  watch: {
    selectJumpLinkFlag(flag) {
      if (this.temporarilyItem && !flag && !this.noClose) {
        this.temporarilyItem.activated = false;
      }
    }
  },
  computed: {
    curComponent() {
      return this.control.curComponent;
    }
  },
  data() {
    return {
      lines: [],
      imgHeight: 0,
      temporarilyItem: null,
      selectJumpLinkFlag: false,
      noClose: false
    };
  },
  methods: {
    visibleChange(flag) {
      this.selectJumpLinkFlag = flag;
    },
    toggleActivated(item, value) {
      // 如果已经打开了，再做切换就不让watch里的执行
      this.noClose = this.selectJumpLinkFlag;
      // 如果下拉选择打开了，就不隐藏菜单栏
      if (this.selectJumpLinkFlag && !value) return;
      if (value) {
        this.temporarilyItem = item;
        this.value.forEach(it => {
          it.activated = false;
        });
      }
      item.activated = value;
    },
    jumpTypeChange(val, index) {
      this.value[index].path = val;
    },
    handleResizestop(index) {
      const selectJumpLink = this.$refs[`selectJumpLink${index}`][0];
      selectJumpLink && selectJumpLink.closeDropDownVisible();
      this.noClose = true;
    },
    handleDragging(x, y, item) {
      const [itemPoint] = this.handlePointData([item]);
      const points = this.handlePointData(this.value);
      let lines = [];
      const diff = 5; // 偏差

      let i = 0;
      while (i < points.length) {
        const item = points[i];
        if (item.id !== itemPoint.id) {
          const { x, y } = itemPoint;
          const xResults = this.findCloseNumbers(x, item.x, diff).map(item => {
            return {
              top: 0,
              left: item
            };
          });
          const yResults = this.findCloseNumbers(y, item.y, diff).map(item => {
            return {
              top: item,
              left: 0
            };
          });
          lines = [...lines, ...xResults, ...yResults];
        }
        i++;
      }
      this.lines = lines;
      item.x = x;
      item.y = y;
    },
    findCloseNumbers(arr1, arr2, diff) {
      arr1.sort((a, b) => a - b);
      arr2.sort((a, b) => a - b);

      let result = [];
      let i = 0;
      let j = 0;

      // 用双指针筛选两个数组差距在diff以内的部分
      while (i < arr1.length && j < arr2.length) {
        let absDiff = Math.abs(arr1[i] - arr2[j]);
        if (absDiff <= diff) {
          result.push(arr2[j]);
          i++;
          j++;
        } else if (arr1[i] < arr2[j]) {
          i++;
        } else {
          j++;
        }
      }

      return result;
    },
    handlePointData(data) {
      return data.map(item => {
        const XstartPoint = item.x;
        const XcenterPoint = item.x + item.width / 2;
        const XendPoint = item.x + item.width;

        const YstartPoint = item.y;
        const YcenterPoint = item.y + item.height / 2;
        const YendPoint = item.y + item.height;
        return {
          id: item.id,
          // solider 比坐标多了2 这里精细一下
          x: [XstartPoint, XcenterPoint - 2, XendPoint - 2],
          y: [YstartPoint, YcenterPoint - 2, YendPoint - 2]
        };
      });
    },
    handleDragstop(index) {
      const [itemPoint] = this.handlePointData([this.value[index]]);
      const x = this.findMatch(
        itemPoint.x,
        this.lines.map(item => item.left)
      );
      const y = this.findMatch(
        itemPoint.y,
        this.lines.map(item => item.top)
      );
      this.value[index].x -= x;
      this.value[index].y -= y;
      this.noClose = true;
      this.lines = [];
    },
    findMatch(arr1, arr2) {
      for (let i = 0; i < arr1.length; i++) {
        const item1 = arr1[i];
        for (let j = 0; j < arr2.length; j++) {
          const item2 = arr2[j];
          const diff = item1 - item2;
          if (Math.abs(diff) <= 5) {
            return diff;
          }
        }
      }
      return 0;
    },
    handleResizing(x, y, width, height, item) {
      item.x = x;
      item.y = y;
      item.width = width;
      item.height = height;
    },
    addHotSpotHandle() {
      const width = 50;
      const height = 50;
      let item = {
        id: generateID(),
        x: 0,
        y: 0,
        width,
        height,
        activated: false,
        path: ""
      };
      this.addHotspot(item, this.value);
      setTimeout(() => {
        const element = document.querySelector(".editItemsBg");
        element.scrollTop = element.scrollHeight;
      }, 300);
    },
    deleteItem(index) {
      this.value.splice(index, 1);
    },
    imgLoad(e) {
      const element = e.target;
      const { height } = element;
      this.imgHeight = height;
    },
    // 检测新热区是否与已存在的热区重叠
    isOverlap(newHotspot, existingHotspots, xBoundVal = 375, yBoundVal) {
      for (var i = 0; i < existingHotspots.length; i++) {
        var existingHotspot = existingHotspots[i];
        if (newHotspot.x + newHotspot.width >= xBoundVal) {
          newHotspot.x = 0;
          newHotspot.y += 3;
        }
        if (newHotspot.y + newHotspot.height >= yBoundVal) {
          newHotspot.x = 0;
          newHotspot.y = 0;
          return false;
        }
        if (
          newHotspot.x < existingHotspot.x + existingHotspot.width &&
          newHotspot.x + newHotspot.width > existingHotspot.x &&
          newHotspot.y < existingHotspot.y + existingHotspot.height &&
          newHotspot.y + newHotspot.height > existingHotspot.y
        ) {
          // 重叠
          return true;
        }
      }
      // 未重叠
      return false;
    },

    // 添加新热区并处理重叠
    addHotspot(newHotspot, existingHotspots,index) {
      const { imgWidth } = this.control.curComponent;
      const { imgHeight } = this;
      while (
        this.isOverlap(newHotspot, existingHotspots, imgWidth, imgHeight)
      ) {
        newHotspot.x += 3;
      }
      if (index) {
        existingHotspots.splice(index, 0, newHotspot);
      } else {
        existingHotspots.push(newHotspot);
      }
    },

    copy(item, value, index) {
      this.addHotspot({ id: generateID(), ...item }, value, index + 1);
    }
  }
};
</script>

<style lang="less" scoped>
.warp {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.hotViewBgScroll {
  width: 375px;
  height: 90%;
  overflow-y: auto;
  overflow-x: hidden;

  .hotViewBg {
    width: 375px;
    height: auto;
    position: relative;
    display: flex;

    img {
      width: 100%;
      height: auto;
    }
    .hotViewItemsBg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;

      .vdr {
        border: 1px solid #2154f4;
      }
    }
    .draggable-item {
      width: 100%;
      height: 100%;
      background: #2154f426;
      border: 1px solid #2154f4;
      span {
        padding: 5px;
        background-color: #2154f4;
        font-size: 12px;
        color: #fff;
        display: inline-block;
      }
    }
    .control-menu {
      display: flex;
      align-items: center;
      padding-top: 5px;
      > div:last-child {
        background: #fff;
        border: 1px solid #e5e5e5;
        width: 25px;
        height: 25px;
        margin-top: 1px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
}

.hotViewEdit {
  flex: 1;
  padding: 0 15px 0 30px;
  .editTitle {
    color: #344563;
    font-size: 14px;
    font-weight: bold;

    span {
      color: #bbbbbb;
      font-size: 12px;
    }
  }

  .editItemsBg {
    max-height: 299px;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 15px 30px 15px 0;
    .editItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      min-height: 62px;
      padding: 10px 10px 10px 15px;
      background: #f8f8fd;
      border-radius: 1px;
      margin-top: 10px;
      > div {
        display: flex;
        align-items: center;
        position: relative;
        width: 100%;
        height: 100%;
        > i {
          background: #fff;
          border-radius: 50%;
          position: absolute;
          font-size: 24px;
          color: #bbb;
          cursor: pointer;
          top: -12px;
          right: -24px;
        }
        > img {
          width: 14px;
          height: auto;
          display: block;
          cursor: pointer;
        }
      }

      .editItemTitle {
        font-size: 12px;
        color: #6f82b3;
        width: 60px;
      }
      .editItemContent {
        display: flex;
        align-items: center;
        font-size: 12px;
        color: #606266;
        margin: 0 14px 0 0;
      }
      .icon-sucaiku-shanchu {
        font-size: 18px;
        color: #acb2c9;
      }
    }
  }

  .addHotSpotBtn {
    width: 100%;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 10px;
    border-radius: 4px;
    background: #2154f4;
    border: none;
  }
}

/deep/ .hotView {
  .handle {
    border-radius: 50%;
    background: #fff;
    border: 2px solid #2154f4;
  }
  .handle-tl {
    top: -5px;
    left: -5px;
  }
  .handle-tm {
    top: -5px;
    left: 50%;
    margin-left: -5px;
  }
  .handle-tr {
    top: -5px;
    right: -5px;
  }
  .handle-mr {
    right: -5px;
  }
  .handle-br {
    bottom: -5px;
    right: -5px;
  }
  .handle-bm {
    bottom: -5px;
    left: 50%;
    margin-left: -5px;
  }
  .handle-bl {
    bottom: -5px;
    left: -5px;
  }
  .handle-ml {
    left: -5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/baseComponents/HotSpot/components/EditHotSpotDialogSection.vue